import { observer } from 'mobx-react';
import * as React from 'react';
import { AlreadyTranslatedText } from '../../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../../Edit/Store';
import { SectionContext } from '../../../../../Types';
import SortTemplate from '../../SortTemplate';
import Store from '../../Store';
import { ExperienceResource, ExperiencesResource, Toggle } from '../../Types';
import ExperiencesFilter from './ExperiencesFilter';
import SubHeader from './SubHeader';
import CardBanner from './CardBanner';

interface Props {
  store: Store;
  filteredExperiences: ExperienceResource[];
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  experiences: ExperiencesResource;
  context: SectionContext;
  toggle: Toggle;
  setToggle: (arg: Toggle) => void;
}

const Heading: React.FC<Props> = ({
  store,
  learningDesignName,
  filteredExperiences,
  learningCollectionStore,
  experiences,
  context,
  toggle,
  setToggle,
}) => (
  <div>
    <div className="px-11">
      <div className="flex flex-row flex-wrap items-center justify-between">
        <div className="flex flex-row flex-wrap">
          <ExperiencesFilter
            experiences={experiences}
            store={store}
            toggle={toggle}
            setToggle={setToggle}
          />
        </div>
        <SortTemplate />
      </div>
      <SubHeader
        filteredExperiences={filteredExperiences}
        learningCollectionStore={learningCollectionStore}
        experiences={experiences}
        context={context}
      />
    </div>
    <CardBanner
      learningDesignName={learningDesignName}
      learningCollectionStore={learningCollectionStore}
      context={context}
    />
  </div>
);

export default observer(Heading);
